export default __webpack_public_path__ + "static/media/notice-upgrade.9ddaabab.png";